var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-recaptcha-inline"},[_c('div',{attrs:{"id":_vm.containerId,"data-size":"invisible","data-badge":_vm.position}})])}
var staticRenderFns = []

export { render, staticRenderFns }